package com.essntl.uikit.components.spinner

import androidx.compose.animation.core.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Dp
import com.essntl.uikit.components.icons.EsIcon
import com.essntl.uikit.components.icons.EsIconSize
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsSpinner(
    modifier: Modifier = Modifier,
    color: Color = MaterialTheme.esColorScheme.iconPrimary,
    size: EsSpinnerSize = EsSpinnerSize.Large,
) {
    val spinnerIconRes = remember(size) {
        when (size) {
            EsSpinnerSize.Small -> EsIcons.SpinnerSmall
            EsSpinnerSize.Medium -> EsIcons.SpinnerMedium
            EsSpinnerSize.Large -> EsIcons.SpinnerLarge
        }
    }
    val transition = rememberInfiniteTransition()
    // The current rotation around the circle, so we know where to start the rotation from
    val rotation = transition.animateValue(
        0,
        360,
        Int.VectorConverter,
        infiniteRepeatable(
            animation = tween(
                durationMillis = 1500,
                easing = LinearEasing
            )
        )
    )

    EsIcon(
        res = spinnerIconRes,
        size = size.iconSize,
        tint = color,
        modifier = modifier
            .graphicsLayer {
                rotationZ = rotation.value.toFloat()
            }
    )
}

enum class EsSpinnerSize {
    Small,
    Medium,
    Large;

    val iconSize get() = when (this) {
        Small -> EsIconSize.Small
        Medium -> EsIconSize.Medium
        Large -> EsIconSize.Large
    }
}